<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="题型" prop="type">
            <el-radio-group v-model="ruleForm.type" @change="changType">
              <el-radio-button :label="1">单选</el-radio-button>
              <el-radio-button label="2">多选</el-radio-button>
              <el-radio-button label="3">实操</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label-width="0">
        <el-col :span="12">
          <el-form-item label="排序" prop="list_order">
            <el-input v-model="ruleForm.list_order"> </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="问题" prop="title">
            <el-input v-model="ruleForm.title"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"> </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="科目" prop="subject_tip_ids">
            <el-select v-model="ruleForm.subject_tip_ids" multiple placeholder="请选择">
              <el-option v-for="item in subjectTipList" :key="item.uuid" :label="item.name" :value="item.uuid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12"> </el-col>
      </el-row>
      <el-form-item v-if="ruleForm.type != 3" label="选项" prop="option">
        <el-row v-for="(value, key, index) in ruleForm.option" style="margin-bottom: 10px">
          <el-col :span="1">
            {{ key }}
          </el-col>
          <el-col :span="12">
            <el-input v-model="ruleForm.option[key]"> </el-input>
          </el-col>
          <el-col :span="2" style="padding-left: 20px">
            <el-tag @click="deleteItem(key)">删除</el-tag>
          </el-col>
        </el-row>
        <el-link type="primary" @click="addOption">添加选项</el-link>
      </el-form-item>
      <el-form-item v-if="ruleForm.type != 3" label="正确答案" prop="correct">
        <el-select v-model="ruleForm.correct" multiple :multiple-limit="ruleForm.type == 1 ? 1 : 0">
          <el-option v-for="(value, key, index) in ruleForm.option" :label="key" :value="key"></el-option>
        </el-select>
        <!--  <el-select v-else v-model="ruleForm.correct">
                    <el-option v-for="(value, key, index) in ruleForm.option" :label="key" :value="key"></el-option>

                </el-select> -->
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="得分" prop="score">
            <el-input v-model="ruleForm.score"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="错题解析" prop="analysis">
            <el-input v-model="ruleForm.analysis" type="textarea" maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import fullEdit from "@/components/pub/fulledit.vue";
import { addSubject, editSubject, subjectDetail, subjectTipList } from "@/api/edu.js";
import { getTeacherList } from "@/api/teacher.js";

export default {
  components: {
    imgUpload,
    imgUploads,
    fullEdit,
  },
  data() {
    return {
      dates: [],
      loading: false,
      typeList: [],
      teacherList: [],
      ruleForm: {
        cate_uuid: [],
        option: {},
        subject_tip_ids: [],
      },
      subjectTipList: [],
      rules: {
        title: [
          {
            required: true,
            message: "请输入题目名称",
            trigger: "blur",
          },
        ],
        option: [
          {
            required: true,
            message: "请添加选项",
            trigger: "blur",
          },
        ],
        score: [
          {
            required: true,
            message: "请输入试题得分",
            trigger: "blur",
          },
        ],
        correct: [
          {
            required: true,
            message: "请选择正确答案",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择试题类型",
            trigger: "change",
          },
        ],
        subject_tip_ids: [
          {
            required: true,
            message: "请选择科目类型",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    console.log();
    const row = this.$route.query;
    if (row.uuid) {
      this.getDetail(row);
    }

    this.getTeacher("");
    this.getSubjectTipList();
  },
  methods: {
    // 获取科目列表
    async getSubjectTipList() {
      const res = await subjectTipList({ page_index: 1, page_size: 999 });
      this.subjectTipList = res.data;
    },

    changType(type) {
      console.log(type);
      if (type == 1) {
        if (this.ruleForm.correct instanceof Array) {
          this.ruleForm = {
            ...this.ruleForm,
            correct: this.ruleForm.correct.splice(0, 1),
          };
        }
      } else if (type == 3) {
        this.ruleForm = { ...this.ruleForm, correct: [], option: {} };
      }
    },
    getKey(i) {
      const str = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      return str[i];
    },
    addOption() {
      if (!this.ruleForm.option || Array.isArray(this.ruleForm.option) || typeof this.ruleForm.option !== "object") {
        this.ruleForm.option = {};
      }
      const a = Object.keys(this.ruleForm.option).length;
      const str = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      this.$set(this.ruleForm.option, str[a], "");

      console.log(this.ruleForm);
    },
    deleteItem(key) {
      this.$delete(this.ruleForm.option, key);
    },
    async getDetail(row) {
      const res = await subjectDetail(row.uuid);

      if (res) {
        if (res.cate instanceof Array) {
          res.cate_uuid = res.cate.map((it) => {
            return it.uuid;
          });
        }
        // if (res.banner) {
        //     if (!Array.isArray(res.banner)) {
        //         res.banner = JSON.parse(res.banner)
        //     }
        // }
        this.ruleForm = {
          ...res,
          dates: [res.start_time, res.end_time],
          subject_tip_ids: res.subject_tips.map((v) => v.uuid),
        };
        console.log(res);
      }
    },
    getType() {
      getLiveType().then((res) => {
        console.log(res);
        if (res.data instanceof Array) {
          this.typeList = res.data;
        }
      });
    },
    getTeacher(keyword_search) {
      getTeacherList({
        keyword_search,
      }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    editSave(data, uuid) {
      editSubject(data, uuid).then((res) => {
        if (res) {
          this.$message.success("编辑成功");

          this.$router.go(-1);
        }
      });
    },
    addSave(data) {
      addSubject(data).then((res) => {
        if (res) {
          this.$message.success("新增成功");

          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            paper_uuid: this.$route.query.paper_uuid,
            subject_tip_ids: JSON.stringify(this.ruleForm.subject_tip_ids),
          };
          if (this.ruleForm.uuid) {
            this.editSave(data, this.ruleForm.uuid);
          } else {
            this.addSave(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}
</style>
